import i18n from '@/core/i18n';

import { TeamMemberFieldNameDTO } from '../../types/dto/team-member-changed-field.dto';

/**
 * Maps field name DTO to localized field name
 */
export const getLocalizedFieldName = (fieldName: TeamMemberFieldNameDTO | string): string => {
  const fieldNameMap: Record<TeamMemberFieldNameDTO, string> = {
    [TeamMemberFieldNameDTO.STATUS]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.status'
    ),
    [TeamMemberFieldNameDTO.DEPARTMENT]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.department'
    ),
    [TeamMemberFieldNameDTO.ROLE]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.role'
    ),
    [TeamMemberFieldNameDTO.SENIORITY]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.seniority'
    ),
    [TeamMemberFieldNameDTO.LOCATION]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.location'
    ),
    [TeamMemberFieldNameDTO.MANAGER]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.manager'
    ),
    [TeamMemberFieldNameDTO.IS_MANAGER]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.isManager'
    ),
    [TeamMemberFieldNameDTO.MEMBERSHIP_TYPE]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.membershipType'
    ),
    [TeamMemberFieldNameDTO.CAPACITY]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.capacity'
    ),
    [TeamMemberFieldNameDTO.TOTAL_WORKING_MINUTES]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.availableHoursPerDay'
    ),
    [TeamMemberFieldNameDTO.ON_DEMAND]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.onDemand'
    ),
    [TeamMemberFieldNameDTO.INTERNAL_RATE]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.internalRate'
    ),
    [TeamMemberFieldNameDTO.EXTERNAL_RATE]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.externalRate'
    ),
    [TeamMemberFieldNameDTO.IS_HOURLY_RATED]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.isHourlyRated'
    ),
    [TeamMemberFieldNameDTO.CURRENCY]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.currency'
    ),
    // INTEGRATION section
    [TeamMemberFieldNameDTO.GOOGLE]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.google'
    ),
    [TeamMemberFieldNameDTO.JIRA]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.jira'
    ),
    [TeamMemberFieldNameDTO.QUICK_BOOKS]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.quickBooks'
    ),
    [TeamMemberFieldNameDTO.TEMPO]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.tempo'
    ),
    [TeamMemberFieldNameDTO.CLOCKIFY]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.clockify'
    ),
    [TeamMemberFieldNameDTO.BAMBOOHR]: i18n.t(
      'authenticated.team:details.tabs.changes.fieldNames.bambooHR'
    ),
  };

  return fieldNameMap[fieldName as TeamMemberFieldNameDTO] || fieldName;
};
